import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import FinalCTA from "@/components/sections/FinalCTA";

const Home = () => (
  <>
    <Hero />
    <Services />
    <FinalCTA />
  </>
);

export default Home;
